import { Table, TableBody, TableCell, TableHead, TableRow } from '@aws-amplify/ui-react';
import { SourceTypeBadge } from './SourceTypeBadge';
import './EvidenceList.scss';

interface Evidence {
  id?: string;
  observedAt?: string;
  sourceType?: string;
  name?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  normalizedTitle?: string;
  url?: {
    screenshotKey?: string | null;
  };
}

interface EvidenceListProps {
  evidence: Evidence[];
}

function formatMonthYear(dateStr: string | undefined): string {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
}

export function EvidenceList({ evidence }: EvidenceListProps) {
  const sortedEvidence = [...evidence].sort((a, b) => {
    const dateA = a.observedAt ? new Date(a.observedAt).getTime() : 0;
    const dateB = b.observedAt ? new Date(b.observedAt).getTime() : 0;
    return dateB - dateA;
  }).slice(0, 100);

  return (
    <div className="evidence-list">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell as="th">Date</TableCell>
            <TableCell as="th">Source</TableCell>
            <TableCell as="th">Name</TableCell>
            <TableCell as="th">Raw Observed Title</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedEvidence.map((e, i) => (
            <TableRow key={i}>
              <TableCell>{formatMonthYear(e.observedAt)}</TableCell>
              <TableCell><SourceTypeBadge sourceType={e.sourceType} screenshotKey={e.url?.screenshotKey} /></TableCell>
              <TableCell>{[e.firstName, e.middleName, e.lastName].filter(Boolean).join(' ')}</TableCell>
              <TableCell>{e.normalizedTitle || ''}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
